<!-- This will be converted to an iframe by the Vimeo API -->
<div #media></div>

<!-- If Vimeo has no Controls, we need to add our own -->
@if (mediaRepository.displayUIControlZone()) {
  <div class="ui-trigger" (pointerup)="controlZonePointerUp()"></div>
}
